import DoneIcon from '@mui/icons-material/Done';

const TrueIcon: any = () => (
  <DoneIcon color="success"/>
);
export default TrueIcon;
